import { type ComponentPropsWithoutRef, forwardRef } from "react";

import { ButtonGroupSeparator } from "@vega-core/components/shadcn/button-group";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

import { useSplitButtonContext } from "./SplitButtonContext";
import { splitButtonVariants } from "./splitButtonVariants";

export type SplitButtonTriggerProps = ComponentPropsWithoutRef<"button">;

export const SplitButtonTrigger = forwardRef<
  HTMLButtonElement,
  SplitButtonTriggerProps
>(({ children, className, disabled, ...props }, ref) => {
  const { variant } = useSplitButtonContext();

  return (
    <>
      <ButtonGroupSeparator />
      <button
        className={cnTwMerge(
          splitButtonVariants({ variant }),
          "px-2",
          {
            "cursor-not-allowed select-none user-select-none": disabled,
          },
          className,
        )}
        data-testid="split-button-trigger"
        disabled={disabled}
        ref={ref}
        type="button"
        {...props}
      >
        <span className="flex items-center justify-center">{children}</span>
      </button>
    </>
  );
});
